import { render, staticRenderFns } from "./ImagePropertyEditor.vue?vue&type=template&id=ab62aa72&scoped=true&"
import script from "./ImagePropertyEditor.vue?vue&type=script&lang=ts&"
export * from "./ImagePropertyEditor.vue?vue&type=script&lang=ts&"
import style0 from "./ImagePropertyEditor.vue?vue&type=style&index=0&id=ab62aa72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab62aa72",
  null
  
)

export default component.exports